import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const InitialBalanceIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={36}
      fill="none"
      {...props}
    >
      <rect width={36} height={36} fill={theme.palette.grey[200]} rx={18} />
      <path
        stroke={theme.palette.common.black}
        strokeWidth={1.25}
        d="M9.475 15.342c0-.76.616-1.375 1.375-1.375h14.3c.76 0 1.375.615 1.375 1.375v7.7c0 .759-.616 1.375-1.375 1.375h-14.3c-.76 0-1.375-.616-1.375-1.375v-7.7Z"
      />
      <circle
        cx={18}
        cy={19.192}
        r={1.925}
        stroke={theme.palette.common.black}
        strokeWidth={1.25}
      />
      <path
        stroke={theme.palette.common.black}
        strokeLinecap="round"
        strokeWidth={1.25}
        d="M11.4 10.667h13.2"
      />
    </svg>
  );
};
